export default {
  app: {
    privacy: {
      policy: 'pravila privatnosti',
      expansive: 'Korištenjem Expansive-a, prihvaćate Expansive {action}',
      client: '@:app.privacy.expansive{lineBreak}& {clientName} {clientAction}',
    },
    sessionExpired: 'Sesija je istekla',
    sessionExpiredDescription:
      'Vaša sesija je istekla. Prijavite se ponovno za nastavak korištenja aplikacije.',
  },
  components: {
    appContainer: {
      chooseLanguage: 'Odaberite jezik',
      chooseLanguageDescription:
        'Odaberite željeni jezik za aplikaciju. Ovo će promijeniti jezik sučelja i sadržaja.',
    },
    userSelection: {
      cancel: 'Odustani',
      createNewUser: 'Njihovo ime nije na popisu',
      newUser: 'Novi korisnik',
      selectAnExistingUser: 'Odaberite postojećeg korisnika',
      selectUserHint: 'Odaberite postojećeg korisnika ili kreirajte novog za nastavak.',
      startTypingToSearch: 'Počnite tipkati...',
    },
    verification: {
      codeVerification: {
        continue: 'Nastavi',
        header: 'Unesite pristupni kod za lokaciju',
        invalidCode: 'Neispravan kod, pokušajte ponovno.',
      },
      geoVerification: {
        continueWithoutVerifying: 'Nastavi bez provjere lokacije',
        enterSiteAccessCode: 'Unesite pristupni kod za lokaciju',
        locationNotEnabledOrAvailable: 'Zašto vidim ovo?',
        notAvailable: {
          description: 'GPS lokacija nije podržana na ovom uređaju.',
          header: 'Lokacija nije podržana',
        },
        notEnabled: {
          description: 'Usluge lokacije nisu omogućene ili dozvola nije dodijeljena.',
          header: 'Lokacija nije omogućena',
        },
        notVerified: {
          description: 'GPS pokazuje da niste na lokaciji.',
          header: 'Lokacija nije potvrđena',
        },
        tryAgain: 'Pokušaj ponovno',
        unavailable: {
          description: 'Nismo mogli potvrditi vašu GPS lokaciju.',
          header: 'Lokacija nije dostupna',
        },
        unknown: {
          description: 'Ne možemo odrediti vašu lokaciju.',
          header: 'Nepoznata lokacija',
        },
        verified: {
          description: 'GPS pokazuje da ste na lokaciji.',
          header: 'Lokacija potvrđena',
        },
      },
    },
    workOrder: {
      assets: {
        emptyTitle: 'Nema pronađenih sredstava',
        emptyDescription: 'Nema sredstava povezanih s ovim radnim nalogom.',
        warrantyParts: 'Jamstvo na dijelove istječe',
        serialNumber: 'Serijski broj',
        none: '<nema>',
      },
      updates: {
        emptyTitle: 'Nema pronađenih ažuriranja',
        emptyDescription: 'Nema ažuriranja za ovaj radni nalog.',
        unknownUser: 'Nepoznat korisnik',
        none: 'Nema',
        addComment: {
          buttonLabel: 'Dodaj komentar',
        },
      },
      startWorkCheck: {
        startWorkCheckList: {
          hazards: 'Opasnosti',
          no: 'Ne',
          yes: 'Da',
        },
      },
    },
    attachmentsList: {
      attachments: 'Privitci',
      documents: 'Dokumenti',
      siteDocuments: 'Dokumenti lokacije',
    },
  },
  stores: {
    authenticated: {
      startWorkCheckStore: {
        hazards: 'Opasnosti',
        induction: 'Uvod',
        safeToProceed: 'Sigurno za nastavak',
      },
    },
  },
  views: {
    authenticated: {
      sessions: {
        dueBy: 'Rok isteka',
        activeSessions: 'Aktivne sesije',
        activeSessionsDescription:
          'Već ste prijavljeni na sljedeće radne naloge. Morate se odjaviti s ovih radnih naloga prije prijave na novi.',
        resumeSession: 'Nastavi',
        startTime: 'Započeto u',
        unexpectedErrorTitle: 'Neočekivana greška',
        unexpectedErrorMessage:
          'Došlo je do neočekivane greške prilikom kreiranja vaših sesija. Pokušajte ponovno kasnije.',
        engineerNotFound: 'Inženjer nije pronađen',
        engineerNotFoundDescription:
          'Inženjer kojeg pokušavate prijaviti nije pronađen u sustavu. Kontaktirajte svog administratora.',
      },
      verification: {
        code: {
          description:
            'Za prijavu, zatražite 4-znamenkasti kod od voditelja lokacije ili ovlaštene osobe.',
        },
        geo: {
          continue: 'Nastavi',
        },
      },
      workOrders: {
        checkout: {
          index: {
            signOff:
              'Molimo dohvatite pristupni kod od voditelja lokacije ili određenog kontakta kako biste dovršili posjet.',
            checkOut: 'Odjava',
            completeBeforeLeaving: 'Ispunite sljedeći obrazac prije odlaska.',
            continue: 'Nastavi',
            noResolutionSelected: 'Odaberite rješenje prije nastavka.',
            quoteRequired: {
              hint: 'Posjet završen, ponuda slijedi',
              label: 'Potrebna ponuda',
            },
            returnVisitRequired: {
              hint: 'Ponovno ćemo doći za dovršetak',
              label: 'Potreban ponovni posjet',
            },
            serviceCompleted: {
              hint: 'Nisu potrebne daljnje radnje',
              label: 'Usluga dovršena',
            },
            uploadCheckout: 'Učitajte datoteku, fotografiju ili video',
            visitNotes: 'Bilješke o posjetu',
            workOrderResolution: 'Rješenje radnog naloga',
            enterNotes: 'Unesite bilješke ovdje...',
            errors: {
              timedOut: 'Vrijeme isteklo, prekoračeno 30 sekundi. Pokušajte ponovno.',
              closingSession: 'Greška pri zatvaranju sesije',
            },
          },
          success: {
            description:
              'Hvala na posjeti {site}. | {site} još ima 1 otvoreni radni nalog. | {site} još ima {count} otvorenih radnih naloga.',
            endVisit: 'Završi posjet',
            header: 'Uspješno ste se odjavili',
            viewWorkOrders: 'Prijavite se na drugi radni nalog',
          },
          verification: {
            code: {
              description:
                'Za odjavu, zatražite 4-znamenkasti kod od voditelja lokacije ili ovlaštene osobe.',
              continue: 'Nastavi',
            },
            geo: {
              checkOut: 'Odjava',
              continue: 'Nastavi',
            },
          },
        },
        detail: {
          assets: 'Sredstva',
          call: 'Poziv',
          checkOut: 'Odjava',
          closed: 'Zatvoreno',
          details: 'Detalji',
          dueBy: 'Rok isteka',
          manageEngineers: 'Upravljaj inženjerima',
          notAvailable: 'Nije dostupno',
          pointOfContact: 'Kontakt osoba',
          siteAccessTimes: 'Vrijeme pristupa lokaciji',
          siteAccessInstructions: 'Upute za pristup',
          siteAddress: 'Adresa lokacije',
          siteNotes: 'Bilješke o lokaciji',
          siteTelephone: 'Telefon lokacije',
          siteLocation: 'Lokacija',
          updates: 'Ažuriranja',
          more: 'Više',
          mismatchErrorTitle: 'Greška radnog naloga',
          mismatchErrorMessage:
            'Radni nalog kojem pokušavate pristupiti ne odgovara onome na koji ste trenutno prijavljeni. Provjerite radni nalog i pokušajte ponovno.',
          siteDocuments: 'Dokumenti lokacije',
          validFrom: 'Vrijedi od',
          validUntil: 'Vrijedi do',
          documentName: 'Naziv dokumenta',
          documentType: 'Vrsta dokumenta',
          attachments: 'Datoteke radnog naloga',
          download: 'Preuzmi',
          workDetails: 'Detalji rada',
        },
        engineers: {
          assistants: {
            addAssistantEngineer: 'Dodaj pomoćnog inženjera',
            assistantEngineers: 'Pomoćni inženjeri',
            description: 'Iz sigurnosnih razloga navedite imena svih inženjera na lokaciji.',
            editMainEngineer: 'Uredi glavnog inženjera',
            errors: {
              creatingEngineer: 'Greška pri kreiranju inženjera',
              creatingSession: 'Greška pri kreiranju sesije',
            },
            header: 'Inženjeri na lokaciji',
            mainEngineer: 'Glavni inženjer',
            newAssistantEngineer: 'Unesite njihovo puno ime',
            next: 'Dalje',
            removeEngineer: 'Ukloni inženjera',
            selectExistingAssistantEngineer: 'Počnite tipkati njihovo ime',
          },
          index: {
            description: 'Iz sigurnosnih razloga navedite imena svih inženjera na lokaciji.',
            errorCreatingEngineer: 'Greška pri kreiranju inženjera, pokušajte ponovno.',
            header: 'Inženjeri na lokaciji',
            hintMainEngineer: 'Unesite puno ime glavnog inženjera',
            newMainEngineer: 'Novi glavni inženjer',
            next: 'Dalje',
            selectExistingMainEngineer: 'Odaberite postojećeg glavnog inženjera',
            yes: 'Da',
            no: 'Ne',
            mainEngineerLabel: 'Jeste li vi glavni inženjer?',
          },
        },
        index: {
          callUsOn: 'Nazovite nas na {phoneNumber}',
          description: 'Ne možete pronaći što tražite?',
          dueBy: 'Rok isteka',
          header: 'Odaberite radni nalog',
          notAvailable: 'Nije dostupno',
          searchWorkOrders: 'Pretraži radne naloge...',
        },
        manageEngineers: {
          manageEngineers: 'Upravljaj inženjerima',
          notWorking: 'Neaktivni radnici',
          pause: 'Pauza',
          resume: 'Nastavi',
          workingNow: 'Aktivni radnici',
          startTime: 'Vrijeme početka',
          endTime: 'Vrijeme završetka',
          duration: 'Trajanje',
        },
        startWorkChecks: {
          feedback: {
            feedbackTitle: 'Povratna informacija',
            feedbackDescription:
              'Molimo vas da date povratnu informaciju o radnom nalogu kako bismo poboljšali naše usluge.',
            feedbackLabel: 'Povratna informacija',
            filesLabel: 'Privitci',
            submissionLabel: 'Pošalji povratnu informaciju',
          },
          hazards: {
            back: 'Natrag',
            hazards: 'Opasnosti',
            next: 'Dalje',
            no: 'Ne',
            noTasksForHazard: 'Nema zadataka za ovu opasnost.',
            yes: 'Da',
          },
          induction: {
            continue: 'Nastavi',
            induction: 'Uvod',
          },
          index: {
            checkIn: 'Prijava',
            description: 'Ispunite sljedeću procjenu rizika za odabrani rad.',
            fail: 'Neuspješno obrađivanje provjera početka rada.',
            haltMessage:
              'Otkriveni su potencijalni rizici. Zaustavite rad, proučite sigurnosne smjernice i kontaktirajte nadređenog za daljnje upute.',
            header: 'Provjere početka rada',
            endVisit: 'Završi posjet',
            leaveFeedback: 'Ostavite povratnu informaciju',
          },
          safeToProceed: {
            continue: 'Nastavi',
            safeToProceed: 'Sigurno za nastavak',
          },
        },
      },
    },
    index: {
      title: 'Dobrodošli',
      description: 'Skenirajte QR kod na svojoj lokaciji za početak.',
    },
    login: {
      errorTitle: 'Neočekivana greška',
      errorMessage: 'Došlo je do neočekivane greške. Pokušajte ponovno skenirati QR kod.',
    },
    unauthenticated: {
      welcome: {
        title: 'Dobrodošli u {site}',
        description:
          'Prije nego što vam prikažemo radne naloge, moramo provjeriti vaše podatke. Kliknite gumb ispod za nastavak.',
        next: 'Nastavi',
      },
      index: {
        errorTitle: 'Neočekivana greška',
        errorMessage: 'Došlo je do neočekivane greške. Pokušajte ponovno skenirati QR kod.',
      },
      contractor: {
        title: 'Za koga radite?',
        contractor: 'Izvođač',
        contractorLabel: 'Počnite tipkati naziv svoje tvrtke',
        contractorHint: 'Morate unijeti 3 ili više znakova za prikaz rezultata',
        defaultSelectPlaceholder: '--Odaberite--',
        next: 'Dalje',
      },
      user: {
        title: 'Tko ste vi?',
        cancel: 'Odustani',
        createNewUserLabel: 'Moje ime nije na popisu',
        existingUserLabel: 'Počnite tipkati svoje ime',
        existingUserHint: 'Morate unijeti 3 ili više znakova za prikaz rezultata',
        newUserLabel: 'Unesite svoje puno ime',
        next: 'Dalje',
        user: 'Korisnik',
      },
      verification: {
        methods: {
          add: {
            add: 'Dodaj metodu provjere',
            defaultSelectPlaceholder: '--Odaberite--',
            emailLabel: 'E-mail',
            existingMethodWarning:
              'Već imate zahtjev za ovu metodu provjere koji čeka odobrenje administratora. Dodavanje nove će ga zamijeniti.',
            method: 'Metoda',
            methodLabel: 'Metoda',
            mobileCountryHint: 'Odaberite pozivni broj države',
            mobileCountryLabel: 'Pozivni broj države',
            mobileHint: 'Unesite svoj broj mobitela',
            mobileLabel: 'Mobitel',
            title: 'Dodaj metodu provjere',
          },
          confirm: {
            confirm: 'Potvrdi',
            description: 'Potvrdite svoju metodu provjere za nastavak.',
            label: 'Unesite svoj kod',
            resend: 'Ponovno pošalji',
            resendPrompt: 'Niste primili kod?',
            title: 'Potvrda metode provjere',
          },
          confirmed: {
            description:
              'Bit ćete obaviješteni kada ova metoda provjere bude odobrena od strane administratora, tada ćete je moći koristiti za provjeru identiteta.',
            forceApproval: 'Dok ne bude odobrena, ne možete pristupiti radnim nalozima.',
            nonForceApproval:
              'U međuvremenu možete nastaviti s ograničenim pristupom radnim nalozima.',
            nonForceApprovalButtonLabel: 'Nastavi s ograničenim pristupom',
            title: 'Čeka se odobrenje',
          },
          addNew: 'Dodaj novu metodu provjere',
          description:
            'Moramo provjeriti vaš identitet kako bismo vam omogućili puni pristup radnom nalogu.',
          email: 'E-mail',
          hint: 'Poslat ćemo poveznicu na odabranu metodu provjere koja vam daje puni pristup radnom nalogu. Ako trebate promijeniti postojeće metode provjere, kontaktirajte administratora.',
          label: 'Odaberite metodu provjere',
          next: 'Dalje',
          pendingHint: 'Čeka se odobrenje administratora',
          sms: 'SMS',
          title: 'Provjera',
        },
        optional: {
          hint: 'Provjera vaših podataka omogućit će vam puni pristup radnom nalogu',
          label: 'Želite li provjeriti svoje podatke?',
          next: 'Dalje',
          no: 'Ne',
          noHint:
            'Ne želim provjeriti svoje podatke i nastaviti s ograničenim pristupom radnom nalogu',
          title: 'Provjera',
          yes: 'Da',
          yesHint: 'Želim provjeriti svoje podatke i dobiti puni pristup radnom nalogu',
        },
        sent: {
          description:
            'Poveznica za prijavu poslana je na {identifier}. Kliknite poveznicu za dovršetak prijave.',
          title: 'Poveznica za prijavu poslana',
        },
      },
    },
  },
  utils: {
    getActivityLog: {
      yesterday: 'Jučer',
      today: 'Danas',
      days: {
        monday: 'Ponedjeljak',
        tuesday: 'Utorak',
        wednesday: 'Srijeda',
        thursday: 'Četvrtak',
        friday: 'Petak',
        saturday: 'Subota',
        sunday: 'Nedjelja',
      },
      months: {
        january: 'Siječanj',
        february: 'Veljača',
        march: 'Ožujak',
        april: 'Travanj',
        may: 'Svibanj',
        june: 'Lipanj',
        july: 'Srpanj',
        august: 'Kolovoz',
        september: 'Rujan',
        october: 'Listopad',
        november: 'Studeni',
        december: 'Prosinac',
      },
    },
  },
  composables: {
    useRedirectToError: {
      title: 'Nešto je pošlo po zlu',
      message: 'Pokušajte ponovno skenirati QR kod.',
    },
    useResolveWorkOrderEvents: {
      user: {
        unknown: 'Nepoznat korisnik',
      },
      none: 'Nema',
      types: {
        stateTransition: 'Status promijenjen',
        contractorAssigned: 'Izvođač dodijeljen',
        engineerAssigned: 'Inženjer dodijeljen',
        serviceAssigned: 'Usluga dodijeljena',
        priorityChanged: 'Prioritet promijenjen',
        actionableDateChanged: 'Datum za djelovanje promijenjen',
        dueDateChanged: 'Datum dospijeća promijenjen',
        etaDateChanged: 'Procijenjeni datum dolaska promijenjen',
        spendLimitApproved: 'Odobren limit potrošnje',
        spendLimitCancelled: 'Zahtjev za limit potrošnje otkazan',
        spendLimitRejected: 'Zahtjev za limit potrošnje odbijen',
        spendLimitRequested: 'Zahtjev za limit potrošnje poslan',
        jobSheetUploaded: 'Radni list učitan',
        slaAlertSent: 'Vrijeme za dolazak premašilo SLA',
        issuedWorkPermit: 'Izdana radna dozvola',
        requestForServiceSent: 'Zahtjev za uslugu poslan',
        comment: 'Komentar dodan',
        unknown: 'Nepoznat događaj',
      },
      labels: {
        actionableDate: 'Datum za djelovanje',
        comment: 'Komentar',
        file: 'Datoteka',
        contractor: 'Izvođač',
        dueDate: 'Datum dospijeća',
        etaDate: 'Procijenjeni datum dolaska',
        engineer: 'Inženjer',
        priority: 'Prioritet',
        requestForService: 'Zahtjev za uslugu',
        service: 'Usluga',
        spendLimit: 'Limit potrošnje',
        status: 'Status',
        workPermit: 'Radna dozvola',
      },
    },
  },
}
